import {LOCATION_CHANGE} from 'react-router-redux';
import * as ActionTypes from '../actions/actionTypes';
import {urlBase} from '../config/environment.js';
import {storeUrlHash} from '../utils/url_utils';

// This initial state is *copied* from react-router-redux's
// routerReducer (the property name 'locationBeforeTransitions' is
// because this is designed for use with react-router)
const initialState = { locationBeforeTransitions: null, url_hash: '' };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // Here is the code to set the location state when the user chooses
    // different layers and indicators.
    case ActionTypes.SET_URL_HASH:
      const { url_hash } = action;

      if (url_hash !== state.url_hash) {
        let location = state.locationBeforeTransitions;
        const hash = '';
        location = { ...location, hash, action: 'PUSH' };

        const slash = urlBase && !urlBase.endsWith('/') ? '/' : '';
        const pathname = `${urlBase}${slash}#${url_hash}`;
        storeUrlHash(url_hash);
        location = { ...location, pathname, action: 'PUSH' };
        return { ...state, locationBeforeTransitions: location, url_hash };
      }
      return state;

    // This LOCATION_CHANGE case is copied from react-router-redux's routerReducer
    case LOCATION_CHANGE:
      return { ...state, locationBeforeTransitions: action.payload };

    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/routing.js